<div class="chart-wrap">
  <canvas baseChart
          [data]="chartData"
          [options]="chartOptions"
          [type]="'doughnut'">
  </canvas>
  <div *ngIf="showPercent" class="chart-center"><span>{{ percent }}<span class="percent">%</span></span></div>
</div>
